import React, { useContext, useState } from 'react';

import GlobalContext from '../../../../context/GlobalContext';

import AccountRetrieve from '../../../components/pageComponents/login/AccountRetrieve';
import LoginSection from '../../../components/pageComponents/login/LoginSection';
import {
  ContainerStyled,
  LogoContainerStyled,
  LogoStyled,
} from './login.styles';

import Logo from '../../../../assets/logo.png';

const Layout = ({ children, path }) => (
  <ContainerStyled>
    <LogoContainerStyled>
      <LogoStyled path={path} />
    </LogoContainerStyled>
    {children}
  </ContainerStyled>
);

export default function Login() {
  const { companyData } = useContext(GlobalContext);

  const [isAccountRetrieve, setIsAccountRetrieve] = useState(false);

  const baseURL = process.env.REACT_APP_API;
  const protocol = companyData.subdomain.endsWith('-st') ? 'http' : 'https';

  const path = companyData?.logo?.url
    ? `${protocol}://${companyData.subdomain}.${baseURL}${companyData.logo.url}`
    : Logo;

  if (isAccountRetrieve) {
    return (
      <Layout path={path}>
        <AccountRetrieve setIsAccountRetrieve={setIsAccountRetrieve} />
      </Layout>
    );
  }

  return (
    <Layout path={path}>
      <LoginSection setIsAccountRetrieve={setIsAccountRetrieve} />
    </Layout>
  );
}
